<div class="card">
  <div class="card-header d-flex">
    <div class="row">
      <div class="col-xl-12">
        <div class="row">
          <div class="col-md-12">
            <h4>Blocked Entity</h4>
          </div>
        </div>
 
        <!-- Type toggle buttons -->
        <div class="d-flex gap-3 mt-2">
          <button type="button" [class]="type === 'CUSTOMER' ? 'contact selected' : 'contact'"
            (click)="getDataByType('CUSTOMER')">
            Customer
          </button>
 
          <button type="button" [class]="type === 'MERCHANT' ? 'contact selected' : 'contact'"
            (click)="getDataByType('MERCHANT')">
            Merchant
          </button>
        </div>
      </div>
    </div>
  </div>
 
  <div class="card-body m-0">
    <div class="row mb-2">
      <div class="col-xl-10">
        <button type="button" class="btn bg-danger-custom" *ngIf="permissions.includes('Search')"
          (click)="onExportCSV()">
          Export Excel<i class="feather icon-download"></i></button>
       
          <button type="button" class="btn bg-danger-custom" (click)="quickFilterShowAction($event)">
            Quick Filters<i
            class="feather icon-filter"></i></button>

               <button type="button"  class="btn" 
  [ngClass]="requestsVisible ? 'clicked' : 'bg-danger-custom'" *ngIf="permissions.includes('Requests')" (click)="onRequests()">
            Requests
          </button>
    
   
      </div>
    </div>

        <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      <!-- CUSTOMER FILTERS -->
      <div *ngIf="type === 'CUSTOMER'" class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">
              <label class="col-form-label" for="customerMobile">Customer Number</label>
              <input class="form-control" [(ngModel)]="customerNumber" id="customerNumber"
                placeholder="Customer Number" />
            </div>
 
            <div class="col-sm-4">
              <label class="col-form-label" for="walletId">Wallet ID</label>
              <input class="form-control" [(ngModel)]="walletId" id="walletId" placeholder="Wallet ID" />
            </div>
 
<div class="col-sm-4">
  <label class="col-form-label" for="emiratesId">Emirates ID</label>
  <input
    class="form-control"
    [(ngModel)]="emiratesId"
    id="emiratesId"
    placeholder="Emirates ID"
    maxlength="15"
    type="text"
    pattern="[0-9]*"
    (keypress)="allowOnlyDigits($event)"
    title="Emirates ID must be exactly 15 digits"
  />
</div>


            </div>


                  <div class="row">
            <div class="mb-3 col-md-4" style="margin-top: 4%;">
              <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom" type="button">
                <i class="feather icon-search"></i> Search
              </button>
              <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="type === 'MERCHANT'" class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">
              <label class="col-form-label" for="merchantId">Merchant ID</label>
              <input class="form-control" [(ngModel)]="merchantId" id="merchantId" placeholder="Merchant ID" />
            </div>
 

     <div class="col-sm-4">
              <label class="col-form-label" for="walletId">Wallet ID</label>
              <input class="form-control" [(ngModel)]="walletId" id="walletId" placeholder="Wallet ID" />
            </div>
          </div>
 
          <div class="row">
            <div class="mb-3 col-md-4" style="margin-top: 4%;">
              <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom" type="button">
                <i class="feather icon-search"></i> Search
              </button>
              <button (click)="resetFilter()" class="btn bg-danger-custom" type="button">Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
         <div class="row mb-0" style="min-height: 470px" *ngIf="!requestsVisible">
    <ag-grid-angular
    class="ag-theme-alpine"
    [enableCellTextSelection]="true"
    [columnDefs]="tableSelectedColumn"
    [defaultColDef]="defaultColDef"
    [paginationPageSize]="pageSize"
    [pagination]="true"
    [rowData]="rowData"
    rowSelection="single"
    [suppressPaginationPanel]="true"
    (gridReady)="onGridReady($event)"
    style="width: 100%; height: auto;">
</ag-grid-angular>

       </div>
      
      
    

          <div *ngIf="requestsVisible" class="row mb-0" style="min-height: 470px">
     
<ag-grid-angular  class="ag-theme-alpine"
[enableCellTextSelection]="true"
  [rowData]="unblockRowData"
  [columnDefs]="unblockColumnDefs"
  [defaultColDef]="defaultColDef"
  [pagination]="true"
   [paginationPageSize]="pageSize"
  [suppressPaginationPanel]="true"
  [paginationPageSize]="10"
  style="width: 100%; height: auto;"
  (gridReady)="onGridReady($event)">
</ag-grid-angular>

  </div>
          
    <div class="row mt-0">
      <div class="col-4 col-xs-4 d-flex">
        <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>

<div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
          [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
        </ngb-pagination>
      </div>
      </div>
  </div>
    
  </div>
 
 
  
  
<app-modal #modalUnblockRequest [modalConfig]="modalConfigUnblockRequestForm">
  <app-unblock-request-modal  
    #unblockRequestInner
     (closeModal)="modalUnblockRequest.close()"
    [isInitiator]="isInitiator"
    [customerData]="selectedCustomer"
    [permissions]="permissions"
    [requestsVisible]="requestsVisible"
    (requestApproved)="onRequestApproved()"
     (requestRejected)="onRequestRejected()" 
  (closeModal)="modalUnblockRequest.close()">
  </app-unblock-request-modal>
</app-modal>

  